import { Capacitor } from '@capacitor/core';
import { SupportPlatform } from 'app/models/support';

export function detectPlatform(): SupportPlatform {
  const p = Capacitor.getPlatform();
  if (p === 'ios') return 'ios';
  if (p === 'android') return 'android';
  return 'web';
}

export function stripHtml(html: string): string {
  if (!html) return '';
  if (typeof document !== 'undefined') {
    const div = document.createElement('div');
    div.innerHTML = html;
    return (div.textContent ?? '').replace(/\s+/g, ' ').trim();
  }
  return html.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
}

/** Kort preview-tekst for trådlisten (samme regel for drafts og sendte). */
export function messagePreview(description: string): string {
  const text = stripHtml(description);
  return text.length > 120 ? text.substring(0, 120) + '...' : text;
}
